import { useState } from "react";
import { HeaderMiniCardList } from "./Header";
import "./index.scss";

type ICardBox = {
  children;
  childrenHeader?: any;
  name: string;
  img: string;
  key?: number;
  onClick?: any;
  classNameChildren?: string;
  more?: boolean;
  onMouseEnter?: (e) => void;
  onMouseLeave?: (e) => void;
};

export function CardBox({
  childrenHeader,
  name,
  img,
  key,
  onClick,
  children,
  classNameChildren,
  more = undefined,
  onMouseEnter,
  onMouseLeave,
}: ICardBox) {
  const [hoverButtonAdditionalsCard, setHoverButtonAdditionalsCard] = useState<{ status: boolean; id: number }>();

  return (
    <div
      key={key}
      onClick={!hoverButtonAdditionalsCard?.status && onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`cardBox ${!hoverButtonAdditionalsCard?.status && "hover:ease-in filter hover:brightness-75"}`}
    >
      <HeaderMiniCardList
        img={img}
        name={name}
        id={key}
        more={more}
        hoverButtonAdditionalsCard={hoverButtonAdditionalsCard}
        setHoverButtonAdditionalsCard={setHoverButtonAdditionalsCard}
        children={childrenHeader}
      />
      <div className={`flex flex-col w-full ${classNameChildren}`}>{children}</div>
    </div>
  );
}
